
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuInstaPancakeInstaTopImage } from "@src/constants/images";
import { meta as micasadecoPageMeta } from "./micasadeco.mdx";
import { meta as rainbowPancakePageMeta } from "./rainbow_pancake.mdx";
import { meta as urthcafePageMeta } from "./urthcafe.mdx";
import { meta as uzunaomomPageMeta } from "./uzunaomom.mdx";
import { meta as rizlaboPageMeta } from "./rizlabo.mdx";
export const meta = {
  path: "/media/harajuku/insta_pancake",
  title: "【原宿・表参道】インスタ映えするふわふわパンケーキ５選",
  description: "原宿・表参道でインスタ映え間違いなしのふわふわパンケーキをご紹介させていただきます！パンケーキ激戦区の原宿・表参道で人気のお店から、穴場のお店までご紹介させていただきます！パンケーキ以外にも、インスタ映えスポットもできるお店もご紹介しますので、確認してみてください！",
  topImg: harajukuInstaPancakeInstaTopImage,
  author: murakamiMasanori,
  tags: ["原宿", "人気店", "まとめ記事", "デート", "女子会", "スイーツ", "インスタ映え", "パンケーキ", "穴場"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿・表参道でインスタ映え間違いなしのふわふわパンケーキをご紹介させていただきます！`}</p>
    <p>{`今回はお店を厳選して 5 つに絞っており、その中でも原宿・表参道といえばふわふわパンケーキが大人気のエリアなので、ふわふわパンケーキのお店を厳選して用意させていただきました。`}</p>
    <p>{`人気店や穴場店、オンライン販売ができるお店、インスタ映えスポットなど、他のサイトには載っていないところからご紹介させていただきますのでぜひ確認してください..！`}</p>
    <h2>{`【表参道】リズラボキッチン`}</h2>
    <InstaImage postId="B8s7__snxLj" mdxType="InstaImage" />
    <p>{`表参道から少し歩くと裏参道と呼ばれるエリアがああり、`}<strong parentName="p">{`裏参道ガーデン`}</strong>{` という古民家風のお店にリズラボキッチンはあります！
原宿・表参道エリアの隠れ家パンケーキ屋さんになります！`}</p>
    <p>{`米粉 100%のグルテンフリーで作るふわふわパンケーキが大人気のお店で、テイクアウトやオンライン注文もできるそう！`}</p>
    <h3>{`グルテンフリー リズパンケーキ(税込：1,700 円)`}</h3>
    <InstaImage postId="B-_azukhd5A" mdxType="InstaImage" />
    <p>{`写真からもふわふわが伝わる大きなパンケーキが３つ重なったパンケーキで、インスタ映え間違いなしのメニュー！
北海道産生乳 100%の生クリームに、カナダか産の有機のアンバータイプのメープルシロップをかけて食べる贅沢な一品！`}</p>
    <h3>{`グルテンフリー 抹茶パンケーキ(税込：1,700 円)`}</h3>
    <InstaImage postId="B9dwcOMnG7r" mdxType="InstaImage" />
    <p>{`裏参道ガーデン内の`}<strong parentName="p">{`宇治園`}</strong>{`というお店から届く`}<strong parentName="p">{`抹茶`}</strong>{`をふんだんに使用しており、北海道産の`}<strong parentName="p">{`粒あん`}</strong>{`をたっぷり添えた抹茶パンケーキになっています！
抹茶がふんだんに使われたパンケーキはインスタ映え間違いなし..！`}</p>
    <h3>{`【テイクアウト】北海道産濃厚生クリームパンケーキサンド(税込 1,760 円)　`}</h3>
    <InstaImage postId="B_4HxGSHNW1" mdxType="InstaImage" />
    <p><strong parentName="p">{`テイクアウト・オンライン限定`}</strong>{`のメニューとして、４月からスタートしたこちらのメニューも、箱も含めてインスタ映え間違いなし！`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`表参道から徒歩 5 分、外苑前から徒歩７分、原宿駅から徒歩１０分という好立地！
どちらからもアクセスできる距離になっています！`}</p>
    <GoogleMap lat={35.6695025} lng={139.7215676} mdxType="GoogleMap" />
    <hr></hr>
    <LinkWithThumbnail meta={rizlaboPageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`【原宿】ミカサデコカフェ`}</h2>
    <InstaImage postId="B9qDzXqguvS" mdxType="InstaImage" />
    <p>{`東京、大阪、京都に３店舗を構えるパンケーキの人気店で、2020 年 3 月に神宮前に場所を移転してリニューアルオープン！
`}<strong parentName="p">{`大人が楽しめるカフェ`}</strong>{`をコンセプトに、1 番人気のパンケーキだけでなく、月替りのランチメニューなど、素材にこだ割った食事が食べられるお店として人気上昇中です！`}</p>
    <h3>{`1 番人気のリコッタチーズパンケーキ(1,350 円)`}</h3>
    <InstaImage postId="BwJq_lVnIOh" mdxType="InstaImage" />
    <p>{`写真からふわふわ感が伝わる、インスタ映え間違いなしのパンケーキ！
注文が入ってから一枚一枚焼き上げ、出来上がりに揺らすとふわふわっと揺れるので、インスタのストーリーとして動画に上げるのも良いですよね！`}</p>
    <h3>{`ゆきだるまや鳥居をモチーフに`}</h3>
    <InstaImage postId="B5z9VJUHMHs" mdxType="InstaImage" />
    <h3>{`海の波をモチーフに`}</h3>
    <InstaImage postId="B79oJmYnL-C" mdxType="InstaImage" />
    <h3>{`アクセス`}</h3>
    <p>{`神宮前のキャットストリートに位置するお店で、神宮前から徒歩ですぐ行くことができます！
インスタ映えのパンケーキをミカサデコで..！`}</p>
    <GoogleMap lat={35.6665261} lng={139.7032377} mdxType="GoogleMap" />
    <hr></hr>
    <LinkWithThumbnail meta={micasadecoPageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`【原宿】ウズナオムオム(uzuna omom)`}</h2>
    <InstaImage postId="BsXA8poA5ay" mdxType="InstaImage" />
    <p>{`原宿パンケーキの穴場的存在で、店内がアットホームで人混みの喧騒を離れた落ち着いた店内になっています！
そんな、ウズナオムオム (uzuna omom)のインスタ映え間違いなしのメニューは月替りのマンスリーパンケーキです！`}</p>
    <h3>{`苺とチョコのティラミス風パンケーキ(税込：1,595 円)`}</h3>
    <InstaImage postId="B8mq6GQAx-K" mdxType="InstaImage" />
    <p>{`2020 年 2 月限定で提供されていた人気のパンケーキメニュー！フォトジェニックでインスタ映えするパンケーキになっています！`}</p>
    <h3>{`桜のパンケーキ(税込：1,595 円)`}</h3>
    <InstaImage postId="B_Y9_ZTALOZ" mdxType="InstaImage" />
    <p>{`2020 年 4 月~5 月にかけて提供されていたパンケーキで、桜をモチーフにしたインスタ映えのパンケーキになっています！`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`原宿と明治神宮駅から徒歩５分程度の距離にあり、マンションの二階にあるのでわかりづらいかもしれませんが、看板が道路に出ているので、そちらを探してください…！`}</p>
    <InstaImage postId="B1czxXwnspZ" mdxType="InstaImage" />
    <GoogleMap lat={35.6570313} lng={139.6926224} mdxType="GoogleMap" />
    <hr></hr>
    <LinkWithThumbnail meta={uzunaomomPageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`【原宿】レインボーパンケーキ`}</h2>
    <InstaImage postId="B4cbRngBO1S" mdxType="InstaImage" />
    <p>{`原宿パンケーキで必ず上位に出てくるパンケーキの名店で、インスタグラムにもたくさんインスタ映えのパンケーキがたくさん載っていることで有名です！`}</p>
    <h3>{`季節のフルーツ(税込：1,350 円)`}</h3>
    <InstaImage postId="B_SSlHSBJWP" mdxType="InstaImage" />
    <p>{`レインボーパンケーキの定番のメニューで、仕入れる旬のフルーツをふわふわのクリーに包みこんだ高さのあるパンケーキ！
この聳え立つようなクリームとフルーツの外観がインスタ映えの一品！`}</p>
    <h3>{`いちごとハニーフロマージュパンケーキ(税込：1,600 円)`}</h3>
    <InstaImage postId="B9g-cjWgrE8" mdxType="InstaImage" />
    <p>{`こちらは期間限定のマンスリーパンケーキで、まるでショートケーキのようなパンケーキでインスタ映え間違いなしの一品！レインボーパンケーキでは、毎月月替りのパンケーキが人気で、特に他のパンケーキに比べてボリューム感があります！`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`原宿駅から徒歩６分の立地なので、アクセスも抜群！原宿で人気のパンケーキ店に行きたい時は、レインボーパンケーキを！`}</p>
    <GoogleMap lat={35.6694626} lng={139.70507} mdxType="GoogleMap" />
    <hr></hr>
    <LinkWithThumbnail meta={rainbowPancakePageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h2>{`【表参道】アースカフェ(Urth Cafe)`}</h2>
    <InstaImage postId="B_rPlppgWaG" mdxType="InstaImage" />
    <p>{`オーガニック食材を使ったメニューが人気のアメリカ発祥のお店で、アメリカでは、ャスティン・ビーバーやマイリー・サイラスなど、芸能人御用達の人気店になっています。
アースカフェ はメニューだけではなく、インスタ映えスポットもあるので、そちらも合わせてご紹介します！`}</p>
    <h3>{`パンケーキ(1,278 円)`}</h3>
    <InstaImage postId="B9qTrR_AaAd" mdxType="InstaImage" />
    <p>{`極厚でふわふわな外観をしたパンケーキの真ん中はハート型になっていてインスタ映え間違いなしの一品。
焼き上がりから 10 分間がふわふわな食感を 1 番楽しめる時間になっているそう！`}</p>
    <h3>{`イチゴ マスカルポーネ パンケーキ(1,500 円)`}</h3>
    <InstaImage postId="BxMTk_aFiwl" mdxType="InstaImage" />
    <p>{`マスカルポーネがたっぷりかかったアースカフェ(Urth Caffe)の人気メニューで、他のお店では中々食べられないオリジナルのパンケーキ！
インスタ映え間違いなしのどっさりとしたクリームとパンケーキが、食欲をそそりますよね！`}</p>
    <h3>{`パンケーキ以外にもインスタ映えのスポットが！`}</h3>
    <InstaImage postId="BwCeGq6hztT" mdxType="InstaImage" />
    <p>{`テラス席にはたくさんのインスタ映えスポットがあり、そちらの方でもパンケーキやドリンクと一緒に写真を撮るのもいかもしれません…！`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`アースカフェ(Urth Caffe)は表参道から徒歩３分の好立地にあり、こんな外観をしているので、すぐに見つけられると思います！
開放的でまさに海外のカフェのようですよね！`}</p>
    <InstaImage postId="Bv1Z3DAArTV" mdxType="InstaImage" />
    <hr></hr>
    <LinkWithThumbnail meta={urthcafePageMeta} mdxType="LinkWithThumbnail" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`インスタ映えするふわふわパンケーキのお店についてご紹介してきましたが、いかがでしたでしょうか？
ぜひ、その日の気分に合わせてインスタ映えができるお店をチェックしてみてください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;